import Vue from "vue";
import Vuex from "vuex";

import cart from './buyer/cart';
import product from './buyer/product';
import products from './buyer/products';
import orderInfo from './buyer/orderInfo';
import twoFactorAuth from './buyer/two-factor-auth';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        cart,
        product,
        products,
        orderInfo,
        twoFactorAuth
    },
    state: {
        modal: null,
    },
    mutations: {
        setActiveModal(state, modal) {
            state.modal = modal;
        },
    },
    getters: {
        isActiveModal: (state) => (modal) => {
            return state.modal === modal;
        }
    }
});

export default store;
